import Vue from 'vue'
import { init } from '@sentry/browser'
import { Vue as SentryVue } from '@sentry/integrations'

if (process.env.NODE_ENV === 'production') {
  init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SUPERCHARGIFY_ENV,
    release: process.env.VUE_APP_COMMIT_REF,
    integrations: [
      new SentryVue({
        Vue,
        attachProps: true
      })
    ]
    // beforeSend (event) {
    //   let fsurl = 'none'

    //   try {
    //     fsurl = window.FS.getCurrentSessionURL(true)
    //   } catch (e) {}

    //   try {
    //     if (!event.tags) event.tags = {}
    //     event.tags.fullstory = fsurl
    //   } catch (e) {}

    //   return event
    // }
  })
}

window.onerror = function (message, source, lineno, colno, error) {
  if (message.includes(`Cannot read property 'style' of undefined`)) return true
  if (message.includes('Failed to update a ServiceWorker')) return true
}
